<template>
  <div
    class="sy-accessory"
    :class="{
      'sy-accessory-edit': type === 'edit',
      'sy-accessory-detail': type === 'detail',
      'sy-accessory-mini': miniMode
    }"
  >
    <!-- 图片 -->
    <template v-if="onlyImage">
      <!-- 图片编辑 -->
      <template v-if="ediTable">
        <AccessoryImg
          v-bind="$attrs"
          v-on="$listeners"
          :pageText="pageText"
          :miniMode="miniMode"
        ></AccessoryImg>
      </template>
      <!-- 图片展示 -->
      <template v-else>
        <AccessoryImgDetail
          :firstImgOnly="firstImgOnly"
          :miniMode="miniMode"
          :fileList="$attrs.fileList"
          :pageText="pageText"
        ></AccessoryImgDetail>
      </template>
    </template>
    <!-- 附件 -->
    <template v-else>
      <!-- 附件编辑 -->
      <template v-if="ediTable">
        <AccessoryFile
          v-bind="$attrs"
          v-on="$listeners"
          :pageText="pageText"
          :miniMode="miniMode"
        ></AccessoryFile>
      </template>
      <!-- 附件展示 -->
      <template v-else>
        <AccessoryFileDetail
          v-bind="$attrs"
          v-on="$listeners"
          :pageText="pageText"
          :allFileList="$attrs.fileList"
          :miniMode="miniMode"
        ></AccessoryFileDetail>
      </template>
    </template>
  </div>
</template>

<script>
import AccessoryFile from './accessory-file'
import AccessoryImg from './accessory-img'
import AccessoryFileDetail from './accessory-file-detail'
import AccessoryImgDetail from './accessory-img-detail'
import i18n from './i18n'

const pageText = window.fe.getPageText(i18n)

export default {
  name: 'sy-accessory',
  props: {
    // 主从
    miniMode: {type: Boolean, default: false},
    // 编辑详情 true编辑 false详情
    ediTable: {type: Boolean},
    // 附件｜图片 true图片 false附件
    onlyImage: {type: Boolean, default: false},
    // 图片 在列表 和 从对象 的展示状态  true列表只显示一张 false从对象
    firstImgOnly: {type: Boolean, default: false}
  },
  components: {
    AccessoryFile,
    AccessoryImg,
    AccessoryFileDetail,
    AccessoryImgDetail
  },
  data () {
    return {
      pageText
    }
  }
}
</script>

<style scoped lang="scss">
// normal
.sy-accessory {
  display: inline-block;
  overflow: hidden;
  font-size: 14px;
  width: 100%;
}
// mini
.sy-accessory-mini {
  font-size: 12px;
}
</style>